<script setup>
import { ref, onMounted, onUnmounted, reactive, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { scrollTo } from 'vue-scrollto';
import productsli1 from "@/assets/images/icon/productsli1.png"
import productsli2 from "@/assets/images/icon/productsli2.png"
import productsli3 from "@/assets/images/icon/productsli3.png"
import productsli4 from "@/assets/images/icon/productsli4.png"
import productsli5 from "@/assets/images/icon/productsli5.png"
import productsli6 from "@/assets/images/icon/productsli6.png"
import productsli7 from "@/assets/images/icon/productsli7.png"
import productsli8 from "@/assets/images/icon/productsli8.png"
import pricingli1 from "@/assets/images/icon/pricingli1.png"
import pricingli2 from "@/assets/images/icon/pricingli2.png"
import solutionsli1 from "@/assets/images/icon/solutionsli1.png"
import solutionsli2 from "@/assets/images/icon/solutionsli2.png"
import solutionsli3 from "@/assets/images/icon/solutionsli3.png"
import solutionsli4 from "@/assets/images/icon/solutionsli4.png"
import solutionsli5 from "@/assets/images/icon/solutionsli5.png"
import aboutli1 from "@/assets/images/icon/aboutli1.png"
import aboutli2 from "@/assets/images/icon/aboutli2.png"
import aboutli3 from "@/assets/images/icon/aboutli3.png"
import aboutli4 from "@/assets/images/icon/aboutli4.png"
import aboutli5 from "@/assets/images/icon/aboutli5.png"
const router = useRouter()

const isTop = ref(true)
const showStatus = ref(false)
const scrollTop = ref(0)
const headerHeight = ref(0)
const isScrolling = ref(false)

const isMobileMenuOpen = ref(false) // 新增：移动端菜单状态
const windowWidth = ref(window.innerWidth) // 新增：窗口宽度

const menuRef = ref([])

const navItems = reactive([
  {
    path: '/',
    text: '首页',
    isMenus: false,
    ariaExpanded: false,
    menuItems: [],
    menuItems1: [],
    extensionsItems: []
  },
  {
    path: '/products',
    text: '功能',
    isMenus: true,
    ariaExpanded: false,
    title: 'Amazon VC ERP',
    extensions: 'DOULLY SaaS平台',
    menuItems: [
      {
        id: 'getOrder',
        img: productsli1,
        text: '获取订单',
        remake: '无缝集成亚马逊，自动获取PO、DF订单',
      },
      {
        id: 'intelligentAccountingPprocessing',
        img: productsli3,
        text: '智能账务处理',
        remake: 'RPA智能化财务，省时省力',
      },
    ],
    menuItems1: [
      {
        id: 'automaticFulfillment',
        img: productsli2,
        text: '自动履约',
        remake: '订单履约全链路自动化处理，无需人工处理',
      },
      {
        id: 'dataStatisticalAnalysis',
        img: productsli4,
        text: '数据统计分析',
        remake: '全面数据统计分析，业务账务及时掌握',
      },
    ],
    extensionsItems: [
      {
        id: 'productsFooter',
        text: '多租户，支持独立部署',
        img: productsli5,
      },
      {
        id: 'productsFooter',
        text: '完美集成电商仓储物流',
        img: productsli6,
      },
      {
        id: 'productsFooter',
        text: '技术优势，性能优越',
        img: productsli7,
      },
      {
        id: 'productsFooter',
        text: '风格简约布局清晰',
        img: productsli8,
      },
    ]
  },
  {
    path: '/pricing',
    text: '价格',
    isMenus: true,
    ariaExpanded: false,
    title: '价格',
    extensions: '购买中常见问题',
    menuItems: [
      {
        id: 'pricing',
        img: pricingli1,
        text: 'Amazon VC ERP',
        remake: 'Amazon VC ERP的价格'
      },
    ],
    extensionsItems: [
      {
        id: 'frequentlyAskedQuestions',
        text: '如何从 Particle Lib获取更新？',
        img: pricingli2,
      },
      {
        id: 'frequentlyAskedQuestions',
        text: '购买后我可以随时更改版本',
        img: pricingli2,
      },
    ]
  },
  {
    path: '/solutions',
    text: '服务',
    isMenus: true,
    ariaExpanded: false,
    title: 'DOULLY SaaS平台',
    extensions: 'SaaS+定制',
    menuItems: [
      {
        id: 'requestTrial',
        img: solutionsli1,
        text: '申请试用',
        remake: '试用到期后，如需继续体验可以联系专属客户经理'
      },
      {
        id: 'accountManagement',
        img: solutionsli3,
        text: '账户管理',
        remake: '试用账户注册及密码管理'
      },
    ],
    menuItems1: [
      {
        id: 'onlineConsultation',
        img: solutionsli2,
        text: '在线咨询',
        remake: '任何问题随时随地联系我们'
      },
      {
        id: 'contactInformation',
        img: solutionsli4,
        text: '联系方式',
        remake: '获取更多资料，请联系我们'
      },
    ],
    extensionsItems: [
      {
        id: 'on-demandCustomization',
        text: '支持按需定制，联合共建',
        img: solutionsli5,
      },
    ]
  },
  {
    path: '/about',
    text: '知道',
    isMenus: true,
    ariaExpanded: false,
    title: '知识与技巧',
    extensions: '行业资讯',
    menuItems: [
      {
        id: 'expertKnowledge',
        img: aboutli1,
        text: '专业知识',
        remake: '有关重要业务主题的文章'
      },
      // {
      //   id: 'customerStories',
      //   img: aboutli3,
      //   text: '客户故事',
      //   remake: '成功客户案例及客户评价'
      // },
    ],
    menuItems1: [],
    extensionsItems: [
      {
        id: 'hotTopics',
        text: '2025年亚马逊销量暴增',
        img: aboutli5,
      },
    ]
  }
])

const activeIndex = ref(-1)

const handleScroll = () => {

  isScrolling.value = true
  // 获取滚动位置
  const scrollPosition = window.scrollY || document.documentElement.scrollTop
  scrollTop.value = scrollTop.value || scrollPosition

  let abs = scrollPosition - scrollTop.value
  if (Math.abs(abs) > headerHeight.value) {
    if ((!isTop.value && abs < 0) || (isTop.value && abs > 0)) {
      isTop.value = !isTop.value
    }
    scrollTop.value = scrollPosition
  }
  // isTop.value = scrollPosition === 0

  // 滚动超过100px才显示状态提示
  showStatus.value = scrollPosition > 100

  // 滚动时收起展开的菜单
  if (activeIndex.value !== -1) {
    closeAllMenus()
  }

  // 滚动时关闭移动端菜单
  if (isMobileMenuOpen.value) {
    closeMobileMenu()
  }

  // 重置滚动标记
  setTimeout(() => {
    isScrolling.value = false
  }, 150)
}

// 监听窗口大小变化
const handleResize = () => {
  windowWidth.value = window.innerWidth
  // 如果窗口宽度大于1280px，确保移动端菜单关闭
  if (windowWidth.value > 1280 && isMobileMenuOpen.value) {
    closeMobileMenu()
  }
}

// 关闭所有菜单
const closeAllMenus = () => {
  if (activeIndex.value !== -1) {
    navItems[activeIndex.value].ariaExpanded = false
    activeIndex.value = -1
  }
}

// 切换移动端菜单
const toggleMobileMenu = (event) => {
  if (event) {
    event.stopPropagation()
  }
  isMobileMenuOpen.value = !isMobileMenuOpen.value
  if (isMobileMenuOpen.value) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
}

// 关闭移动端菜单
const closeMobileMenu = () => {
  isMobileMenuOpen.value = false
  document.body.style.overflow = ''
  closeAllMenus()
}

// 检查当前路由
const isCurrentPage = (path) => {
  return router.currentRoute.value.path === path
}

// 移动端菜单项点击处理
const handleMobileMenuItemClick = (item, index, event) => {
  if (event) {
    event.stopPropagation()
  }
  
  if (item.isMenus) {
    // 阻止默认行为，防止页面跳转
    if (event) {
      event.preventDefault()
    }
    
    if (activeIndex.value === index) {
      navItems[index].ariaExpanded = !navItems[index].ariaExpanded
      if (!navItems[index].ariaExpanded) {
        activeIndex.value = -1
      }
    } else {
      if (activeIndex.value !== -1) {
        navItems[activeIndex.value].ariaExpanded = false
      }
      navItems[index].ariaExpanded = true
      activeIndex.value = index
    }
  } else {
    router.push(item.path)
    closeMobileMenu()
  }
}

// 修改子菜单项点击处理逻辑
const handleMobileSubItemClick = async (item, event) => {
  if (event) {
    event.stopPropagation()
    event.preventDefault()
  }
  
  // 先关闭移动端菜单
  closeMobileMenu()
  
  // 处理不同的跳转逻辑
  if (item.id === 'onlineConsultation') {
    // 在线咨询，延迟执行确保菜单已关闭
    setTimeout(() => {
      document.querySelector('.embed-icon-default')?.click()
    }, 300)
  } else if (item.id === 'accountManagement') {
    // 账户管理，新窗口打开
    window.open('https://saas.aidoully.com/user/profile', '_blank')
  } else if (item.id === 'requestTrial') {
    // 申请试用，跳转注册页面
    router.push('/register')
  } else {
    // 页面内锚点跳转
    try {
      // 延迟执行，确保DOM已更新
      await new Promise(resolve => setTimeout(resolve, 100))
      
      const element = document.getElementById(item.id)
      if (element) {
        scrollTo(element, {
          duration: 800,
          offset: -74,
          easing: 'easeInOut'
        })
      } else {
        console.warn(`元素 #${item.id} 未找到`)
        // 如果找不到元素，尝试跳转到对应页面后再查找
        const path = getPagePathByItemId(item.id)
        if (path) {
          router.push(path)
        }
      }
    } catch (error) {
      console.error('跳转失败:', error)
    }
  }
}

const getPagePathByItemId = (id) => {
  const idToPathMap = {
    'getOrder': '/products',
    'intelligentAccountingPprocessing': '/products',
    'automaticFulfillment': '/products',
    'dataStatisticalAnalysis': '/products',
    'productsFooter': '/products',
    'pricing': '/pricing',
    'frequentlyAskedQuestions': '/pricing',
    'requestTrial': '/solutions',
    'accountManagement': '/solutions',
    'onlineConsultation': '/solutions',
    'contactInformation': '/solutions',
    'on-demandCustomization': '/solutions',
    'expertKnowledge': '/about',
    'customerStories': '/about',
    'hotTopics': '/about'
  }
  
  return idToPathMap[id] || null
}

onMounted(() => {
  const header = document.querySelector('.friendation[is="basis-header"]')
  if (header) {
    headerHeight.value = header.offsetHeight
  }
  window.addEventListener('scroll', handleScroll)
  window.addEventListener('resize', handleResize) // 添加resize监听
  document.addEventListener('click', handleClickOutside)
  // 初始化检查一次
  // handleScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  window.removeEventListener('resize', handleResize) // 移除resize监听
  document.removeEventListener('click', handleClickOutside)
})

const tryout = () => {
  router.push('/register')
  closeMobileMenu()
}

const login = () => {
  // const origin = window.location.origin
  const loginUrl = `https://saas.aidoully.com/app`
  window.open(loginUrl, '_blank')
  closeMobileMenu()
}

const toPage = (item, index) => {
  // 如果是当前页面，只切换菜单展开状态，不进行跳转
  if (isCurrentPage(item.path)) {
    if (activeIndex.value === index) {
      closeAllMenus()
    } else {
      // 关闭之前展开的菜单
      if (activeIndex.value !== -1) {
        navItems[activeIndex.value].ariaExpanded = false
      }
      // 展开当前菜单
      activeIndex.value = index
      item.ariaExpanded = true
    }
  } else {
    // 不同页面，进行跳转并收起菜单
    closeAllMenus()
    router.push(item.path)
  }
}

const goBack = () => {
  router.push('/')
  closeMobileMenu()
}

// 跳转对应模块
const scrollToElement = (id, event) => {
  if (id === "onlineConsultation") {
    document.querySelector('.embed-icon-default').click()
  } else if (id === "accountManagement") {
    window.open('https://saas.aidoully.com/user/profile', '_blank')
  } else if (event) {
    event.preventDefault()
    event.stopPropagation()
  }
  // 点击锚点链接时收起菜单
  closeAllMenus()

  if (id === 'requestTrial') {
    router.push('/register')
    return
  }
  const element = document.getElementById(id);
  scrollTo(element, {
    duration: 800,
    offset: -74,
    easing: 'easeInOut'
  })
}

// 点击其他地方关闭菜单
const handleClickOutside = (event) => {
  const header = document.querySelector('.friendation[is="basis-header"]')
  const mobileMenuDrawer = document.querySelector('.mobile-menu-drawer')
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn')
  if (header && !header.contains(event.target) && mobileMenuDrawer && !mobileMenuDrawer.contains(event.target) &&
    mobileMenuBtn && !mobileMenuBtn.contains(event.target)) {
    closeAllMenus()
  }
}


</script>

<template>
  <!-- 顶部导航栏 -->
  <header class="mainHeader">
    <div class="friendation" is="basis-header"
      :class="{ 'slide-in': isTop, 'slide-out': !isTop, 'menu-expanded': activeIndex !== -1 }" data-scroll-top="true"
      :data-current-state="isTop ? 'visible' : 'hidden'">
      <div class="wrapper">
        <div class="container container-header" style="padding: 0 200px;">
          <div class="content-wrapper">
            <div class="logo">
              <div class="logo-text" @click="goBack"></div>
            </div>
            <div is="basis-mega-menue">
              <nav class="">
                <ul role="menubar">
                  <li role="menuitem" tabindex="0" data-level="0" :aria-expanded="item.ariaExpanded"
                    :data-focus="!item.ariaExpanded" v-for="(item, index) in navItems" :key="item.path"
                    :aria-current="activeIndex == index" @click="toPage(item, index)"
                    :class="{ 'current-page': isCurrentPage(item.path) }" style="margin-left: -8px;">
                    <div class="paddingContainer">
                      <span>{{ item.text }}</span>
                      <span v-if="item.isMenus" class="icon" :aria-hidden="!item.ariaExpanded">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                          <path fill="currentColor"
                            d="m8,9.86L3.35,5.22c-.2-.2-.51-.2-.71,0-.2.2-.2.51,0,.71l4.76,4.76c.33.33.85.33,1.18,0l4.76-4.76c.2-.2.2-.51,0-.71-.2-.2-.51-.2-.71,0l-4.65,4.65Z">
                          </path>
                        </svg>
                      </span>
                      <span v-else class="icon" :aria-hidden="!item.ariaExpanded" style="opacity: 0; margin-right: -10px;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                          <path fill="currentColor"
                            d="m8,9.86L3.35,5.22c-.2-.2-.51-.2-.71,0-.2.2-.2.51,0,.71l4.76,4.76c.33.33.85.33,1.18,0l4.76-4.76c.2-.2.2-.51,0-.71-.2-.2-.51-.2-.71,0l-4.65,4.65Z">
                          </path>
                        </svg>
                      </span>
                    </div>
                    <ul :class="{ 'slide-in': item.ariaExpanded, 'slide-out': !item.ariaExpanded }" v-show="item.isMenus && item.ariaExpanded"
                      role="menu" ref="menuRef">
                      <li class="colsWithTitles" role="menuitem" tabindex="-1" data-level="1">
                        <ul class="list" role="menu">
                          <li class=" " role="menuitem" tabindex="-1" data-level="2">
                            <span class="h5 list-title" id="label-ubpclhwthv">{{ item.title }}</span>
                            <ul role="menu" aria-labelledby="label-ubpclhwthv">
                              <li class="list-item" role="none" v-for="item in item.menuItems" :key="item.text"
                                style="align-items: flex-start;">
                                <div class="list-icon" style="transform: translateY(-15%);background: none;">
                                  <img class="list-icon-image ls-is-cached lazyloaded" v-lazy="item.img" />
                                </div>
                                <div class="list-content">
                                  <a class="h6 list-link-title" role="menuitem" tabindex="-1" data-level="4"
                                    @click="scrollToElement(item.id, $event)">{{ item.text }}<span
                                      class="button button--tertiary"></span></a>
                                  <p class="list-description list-height">
                                    {{ item.remake }}
                                  </p>
                                </div>
                              </li>
                              <li class="reducedGap" role="menuitem" tabindex="-1" data-level="2" aria-expanded="false">
                                <span class="h5 list-title onlyDesktop" id="label-btqrtpttrl">&nbsp;</span>
                                <div class="list-below">
                                  <!-- <a v-if="item.path !== '/about'" class="list-link-below button button--tertiary" role="menuitem"
                                    tabindex="-1" data-level="3">
                                    查看更多功能
                                  </a> -->
                                </div>
                              </li>
                            </ul>
                          </li>
                          <li class=" " role="menuitem" tabindex="-1" data-level="2">
                            <span class="h5 list-title" id="label-ubpclhwthv"><br></span>
                            <ul role="menu" aria-labelledby="label-ubpclhwthv">
                              <li class="list-item" role="none" v-for="item in item.menuItems1" :key="item.text">
                                <div class="list-icon" style="transform: translateY(-75%);background: none;">
                                  <img class="list-icon-image ls-is-cached lazyloaded" v-lazy="item.img" />
                                </div>
                                <div class="list-content">
                                  <a class="h6 list-link-title" role="menuitem" tabindex="-1" data-level="4"
                                    @click="scrollToElement(item.id, $event)">{{ item.text }}<span
                                      class="button button--tertiary"></span></a>
                                  <p class="list-description list-height">
                                    {{ item.remake }}
                                  </p>
                                </div>
                              </li>
                            </ul>
                          </li>
                          <li class="greyBackground reducedGap" role="menuitem" tabindex="-1" data-level="2"
                            style="background: #FCFAFA;box-shadow: 0px 2px 4px 0px rgba(203,202,202,0.5);border-radius: none;">
                            <span class="h5 list-title" id="label-ynubslnqrv">{{ item.extensions }}</span>
                            <ul role="menu" aria-labelledby="label-ynubslnqrv">
                              <li class="list-item noDescription" role="none" v-for="item in item.extensionsItems"
                                :key="item.text">
                                <div class="list-icon">
                                  <img class="list-icon-image ls-is-cached lazyloaded" v-lazy="item.img" />
                                </div>
                                <div class="list-content">
                                  <a class="h6 list-link-title" role="menuitem" tabindex="-1" data-level="4"
                                    @click="scrollToElement(item.id, $event)">{{ item.text }}<span
                                      class="button button--tertiary"></span></a>
                                </div>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="control-wrapper">
            <!-- 移动端菜单按钮 (只在小于1280px时显示) -->
            <div class="mobile-menu-btn" @click="toggleMobileMenu">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="buttons buttons--desktop">
              <button class="button button--cta button--secondary login-button-my"
                style="white-space: nowrap;border: none;" @click="login">
                登录
              </button>
              <button class="button button--cta is-hoverable" style="--x: 38.046875px; --y: 51px" @click="tryout">
                <span class="button--primary-text">免费试用</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <teleport to="body">
      <!-- 遮罩层 -->
      <div class="mobile-menu-overlay" :class="{ 'active': isMobileMenuOpen }" @click="closeMobileMenu"></div>

      <!-- 抽屉菜单 -->
      <div class="mobile-menu-drawer" :class="{ 'active': isMobileMenuOpen }">
        <div class="mobile-menu-header">
          <div class="logo-text" @click="goBack"></div>
          <button class="mobile-close-btn" @click="closeMobileMenu">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div class="mobile-menu-content">
          <div v-for="(item, index) in navItems" :key="item.path" class="mobile-menu-item" :class="{
            'active': activeIndex === index,
            'current-page': isCurrentPage(item.path)
          }">
            <div class="mobile-menu-main" @click="handleMobileMenuItemClick(item, index, $event)">
              <span class="mobile-menu-text">{{ item.text }}</span>
              <span v-if="item.isMenus" class="mobile-menu-arrow">
                <svg :class="{ 'rotate': item.ariaExpanded }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                  <path fill="currentColor"
                    d="m8,9.86L3.35,5.22c-.2-.2-.51-.2-.71,0-.2.2-.2.51,0,.71l4.76,4.76c.33.33.85.33,1.18,0l4.76-4.76c.2-.2.2-.51,0-.71-.2-.2-.51-.2-.71,0l-4.65,4.65Z">
                  </path>
                </svg>
              </span>
            </div>

            <!-- 子菜单 -->
            <transition name="slide-down">
              <div v-if="item.isMenus && item.ariaExpanded" class="mobile-submenu">
                <div v-if="item.title" class="mobile-submenu-title">{{ item.title }}</div>

                <!-- 主菜单项 -->
                <div v-for="menuItem in item.menuItems" :key="menuItem.text" class="mobile-submenu-item"
                  @click.stop="handleMobileSubItemClick(menuItem, $event)">
                  <div class="mobile-submenu-icon">
                    <img :src="menuItem.img" alt="" />
                  </div>
                  <div class="mobile-submenu-content">
                    <div class="mobile-submenu-text">{{ menuItem.text }}</div>
                    <div class="mobile-submenu-desc">{{ menuItem.remake }}</div>
                  </div>
                </div>

                <div v-for="menuItem in item.menuItems1" :key="menuItem.text" class="mobile-submenu-item"
                  @click.stop="handleMobileSubItemClick(menuItem, $event)">
                  <div class="mobile-submenu-icon">
                    <img :src="menuItem.img" alt="" />
                  </div>
                  <div class="mobile-submenu-content">
                    <div class="mobile-submenu-text">{{ menuItem.text }}</div>
                    <div class="mobile-submenu-desc">{{ menuItem.remake }}</div>
                  </div>
                </div>

                <!-- 扩展项 -->
                <div v-if="item.extensions" class="mobile-submenu-title">{{ item.extensions }}</div>
                <div v-for="extItem in item.extensionsItems" :key="extItem.text" class="mobile-submenu-item"
                  @click.stop="handleMobileSubItemClick(extItem, $event)">
                  <div class="mobile-submenu-icon">
                    <img :src="extItem.img" alt="" />
                  </div>
                  <div class="mobile-submenu-content">
                    <div class="mobile-submenu-text">{{ extItem.text }}</div>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <!-- 移动端按钮 -->
          <div class="mobile-menu-actions">
            <button class="mobile-btn mobile-btn-login" @click="login">
              登录
            </button>
            <button class="mobile-btn mobile-btn-try" @click="tryout">
              免费试用
            </button>
          </div>
        </div>
      </div>
    </teleport>
  </header>
</template>
<style scoped>
.logo-text {
  width: 142px;
  height: 42px;
  background: url('/src/assets/images/logo-red.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}

.slide-in {
  animation: slideIn 0.3s ease-out forwards;
}

.slide-out {
  animation: slideOut 0.3s ease-out forwards;
}

@keyframes slideIn {
  from {
    transform: translateY(0);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(0);
    opacity: 0;
  }
}

.list-height {
  height: 60px;
}

.friendation[is="basis-header"].menu-expanded {
  /* 当菜单展开时，可以添加一些特殊样式 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* 当前页面菜单项的高亮样式 */
[role="menuitem"].current-page .paddingContainer {
  font-weight: bold;
  color: #FE4554;
}

/* 菜单展开时的平滑动画 */
[role="menu"] {
  transition: all 0.3s ease;
}

[role="menu"].slide-in {
  animation: slideDown 0.3s ease;
}

[role="menu"].slide-out {
  animation: slideUp 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(-10px);
  }
}

.login-button-my:hover {
  background: none !important;
}
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 28px;
  height: 20px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1002;
  margin-left: 20px;
}

.mobile-menu-btn span {
  display: block;
  height: 4px;
  width: 100%;
  background-color: #FE4554;
  border-radius: 4px;
  transition: all 0.3s ease;
}

/* 移动端菜单遮罩层 */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.mobile-menu-overlay.active {
  opacity: 1;
  visibility: visible;
}

/* 抽屉式菜单 */
.mobile-menu-drawer {
  position: fixed;
  top: 0;
  right: -100%;
  width: 85%;
  max-width: 400px;
  height: 100%;
  background-color: white;
  z-index: 9999;
  box-shadow: -2px 0 20px rgba(0, 0, 0, 0.15);
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mobile-menu-drawer.active {
  right: 0;
}

/* 抽屉头部 */
.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.mobile-close-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.mobile-close-btn:hover {
  background-color: #f5f5f5;
}

.mobile-close-btn svg {
  width: 24px;
  height: 24px;
  stroke: #333;
}

/* 菜单内容区域 */
.mobile-menu-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px 0;
}

/* 菜单项 */
.mobile-menu-item {
  border-bottom: 1px solid #eee;
}

.mobile-menu-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.mobile-menu-main:hover {
  background-color: #f9f9f9;
}

.mobile-menu-item.current-page .mobile-menu-main {
  color: #FE4554;
  font-weight: bold;
}

.mobile-menu-text {
  flex: 1;
}

.mobile-menu-arrow svg {
  width: 16px;
  height: 16px;
  transition: transform 0.3s ease;
  margin-left: 10px;
}

.mobile-menu-arrow svg.rotate {
  transform: rotate(180deg);
}

/* 子菜单动画 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: max-height 0.3s ease;
  overflow: hidden;
}

.slide-down-enter-from,
.slide-down-leave-to {
  max-height: 0;
}

.slide-down-enter-to,
.slide-down-leave-from {
  max-height: 1000px;
}

.mobile-submenu {
  background-color: #f9f9f9;
  padding: 10px 0;
}

.mobile-submenu-title {
  padding: 12px 20px 8px;
  font-size: 14px;
  color: #666;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mobile-submenu-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 20px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.mobile-submenu-item:hover {
  background-color: #f0f0f0;
}

.mobile-submenu-icon {
  width: 32px;
  height: 32px;
  margin-right: 12px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-submenu-icon img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.mobile-submenu-content {
  flex: 1;
}

.mobile-submenu-text {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #333;
}

.mobile-submenu-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}

/* 移动端按钮 */
.mobile-menu-actions {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
}

.mobile-btn {
  width: 100%;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  border: none;
  transition: all 0.2s;
}

.mobile-btn-login {
  background-color: transparent;
  border: 1px solid #ddd;
  color: #333;
}

.mobile-btn-login:hover {
  background-color: #f5f5f5;
}

.mobile-btn-try {
  background-color: #FE4554;
  color: white;
}

.mobile-btn-try:hover {
  background-color: #e03e4d;
}

/* 响应式设计 */
@media (max-width: 1440px) {
  .container-header {
    padding: 0 !important;
  }
}

@media (max-width: 1280px) {
  .desktop-menu {
    display: none !important;
  }
  
  .mobile-menu-btn {
    display: flex;
  }
  
  .buttons--desktop {
    display: none !important;
  }
  
  .control-wrapper {
    display: flex;
    align-items: center;
  }
}

@media (min-width: 1281px) {
  .mobile-menu-btn {
    display: none !important;
  }
  
  .mobile-menu-overlay,
  .mobile-menu-drawer {
    display: none !important;
  }
}
</style>
